import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const ProposalsBuilderPreview = () => import('@/pmd/pages/payments/ProposalsBuilderPreview.vue')

export const DocumentsContractsBuilderPreviewRoute: RouteConfig[] = [
  {
    path: 'payments/proposals-estimates/edit/preview/:id',
    name: 'proposals-estimates-edit-preview',
    component: ProposalsBuilderPreview,
    beforeEnter: requireAuthAndLocation,
    children: [],
    meta: {
      hideSideBar: true,
      hideTopBar: true,
    },
  },
]
